import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_ONBOARDING_SUNRISE_TOGGLE = createFcmDetails('starter_onboarding_sunrise_toggle', {
	owner: 'starfish',
	context: 'starter onboarding',
	description: 'Toggles sunrise experience in starter onboarding',
	import: false,
});
